import { when } from 'cerebral/operators'
import { props, resolveObject } from 'cerebral/tags'
import addToBasket from '../actions/addToBasket'
import setOrder from 'modules/App/actions/setOrder'
import createSnackbar from 'modules/App/factories/createSnackbar'

export default [
  addToBasket,
  when(props`rejected`, rejected => rejected.length > 0),
  {
    true: [
      createSnackbar(
        resolveObject({
          key: 'bms.orderBasket.errors.rejected',
          params: resolveObject({ count: props`rejectedCount` })
        }),
        'error'
      )
    ],
    false: []
  },
  setOrder,
  ({ props }) => {
    return {
      fileLength: props.currentFiles.length - props.rejectedCount
    }
  },
  when(props`fileLength`, fileLength => fileLength > 0),
  {
    true: [
      createSnackbar(
        resolveObject({
          key: 'bms.orderBasket.added',
          params: resolveObject({ count: props`fileLength` })
        })
      )
    ],
    false: []
  }
]



// WEBPACK FOOTER //
// ./src/modules/Basket/chains/addToBasket.js